/* AA — Localization <details> defensive close-on-load
   Goal: prevent country/language selector lists from rendering expanded inline.
   - Closes any open <details> elements inside localization forms in header/footer.
   - Does not block normal toggle behavior.
*/

(function () {
  'use strict';

  function closeAllLocalizationDetails(root) {
    if (!root) return;

    var details = root.querySelectorAll('details');
    details.forEach(function (d) {
      try {
        d.removeAttribute('open');
      } catch (e) {}

      var summary = d.querySelector('summary');
      if (!summary) return;

      if (summary.dataset.aaLocBound === '1') return;
      summary.dataset.aaLocBound = '1';

      // Let native behavior toggle; just ensure it isn't stuck open on load.
      summary.addEventListener('click', function () {
        // no-op: handler exists only to avoid double-binding and provide a hook if needed.
      });
    });
  }

  function boot() {
    var targets = document.querySelectorAll(
      'header localization-form, footer localization-form, header .localization-form, footer .localization-form, header [data-localization-form], footer [data-localization-form]'
    );

    if (!targets.length) {
      // Fallback: close any suspicious details that contain the common country selector list.
      closeAllLocalizationDetails(document);
      return;
    }

    targets.forEach(function (t) {
      closeAllLocalizationDetails(t);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (evt) {
    if (!evt || !evt.target) return;
    closeAllLocalizationDetails(evt.target);
  });
})();
